function handleGtmSearchEvent(gtmEventName, searchTermInput) {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];

    // Explicitly set empty value if search is empty
    var searchTermValue = searchTermInput.length > 0 ? searchTermInput : '<empty search>';

    window.dataLayer.push({
        event: gtmEventName,
        searchTerm: searchTermValue,
    });
}

export { handleGtmSearchEvent };
